import { createApiClient } from '@betstarters/api'

const api = createApiClient({
  baseURL: `${import.meta.env.VITE_API_URL || ''}/api/v1`,
})

export default api
